import React, {useState, useEffect} from 'react';
import '../css/App.css';
import '../css/bootstrap.min.css';
import bootstrap from 'bootstrap'

class PlaceHolderBoard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user,
      permissions: this.props.permissions
    };
  }

  render() {
    return(
        <div className='board'>
            <h2>{this.props.title}</h2>
        </div>
    );
  }
}

export default PlaceHolderBoard;